export default __webpack_public_path__ + "static/articles-hepato-da-namalim-riska-fdcc9105d055f3f425034aca90f572de.jpg";